<template>
  <div id="instructions">
    <div class="instructions_body">
      <!-- <h1>Cicadasing Installation Instructions</h1>
      <ul class="ul">
        <li>
          <h5>System Requirements</h5>
          <ul class="ul_i">
            <li>Currently, Cicadasing supports OS cenos7/centos8/Debian8/Debian9/Debian10/ubuntu16/ubuntu18/ubuntu20.</li>
            <li>The memory of VPS/SERVER machine should lager than 1G.</li>
          </ul>
        </li>
        <li>
          <h5>Preparations</h5>
          <ul class="ul_i">
            <li>Check if you install wget tool.</li>
            <li>Cenos series,please use “yum -y install wget” install wget</li>
            <li>Ubuntu/ Debian series, please use “apt -y install wget” install wget</li>
          </ul>
        </li>
        <li>
          <h5>Start Cicadasing installer</h5>
          <ul class="ul_i">
            <li>Check if you install wget tool.</li>
            <li>wget -k http://www.cicadasing.com/cm-server-soft-new.tar -O cm-server-soft-new.tar &amp;&amp; tar -xvf</li>
            <li>warn： Remmber close firewall or open the port which you setted when installing.</li>
          </ul>
        </li>
        <li>
          <h5>Get technical support</h5>
          <ul class="ul_i">
            <li>If occur some issue when using, please send email to cicadasing@protonmail.com for technology support.</li>
          </ul>
        </li>
      </ul> -->
        <h1>蝉鸣(Cicadasing)安装说明</h1>
        <ul class="ul">
          <li>
            <h5>操作系统要求</h5>
            <ul class="ul_i">
              <li>蝉鸣目前支持的操作系统版本：centos7/centos8/Debian8/Debian9/Debian10/ubuntu16/ubuntu18/ubuntu20</li>
              <li>操作系统内存至少为1G</li>
            </ul>
          </li>
          <li>
            <h5>安装前准备</h5>
            <ul class="ul_i">
              <li>检查是否已安装wget命令行工具</li>
              <li>Centos系列,登录系统后,请执行 <i>yum -y install wget</i> 命令 安装wget工具</li>
              <li>Ubuntu和Debian 系列, 登录系统后,请执行 <i>apt -y install wget</i> 命令安装wget工具</li>
              <li>如果安装想使用域名证书，确保防火墙已经开放80端口(安装完成后即可关闭)</li>
            </ul>
          </li>
          <li>
            <h5>安装蝉鸣</h5>
            <ul class="ul_i">
              <li>
                <h5>安装命令</h5>
                <ul class="ul_i">
                  <!-- <li>cd /root &amp;&amp; wget -k  http://www.cicadasing.com/ cicadasing-server.tar -O  cicadasing-serve.tar &amp;&amp; tar -xvf cicadasing-serve.tar &amp;&amp; cd cicadasing-serve &amp;&amp; chmod +x setup.sh &amp;&amp; bash setup.sh</li> -->
                  <li>使用root用户登录后，执行以下命令:</li>
                  <li>cd /root &amp;&amp; wget -k  http://www.cicadasing.com/cicadasing-server.tar -O  cicadasing-server.tar &amp;&amp; tar -xvf cicadasing-server.tar &amp;&amp; cd cicadasing-server &amp;&amp; chmod +x setup.sh &amp;&amp; bash setup.sh</li>
                  <li>安装完成后会显示后台管理的登录地址，初始用户名和密码等</li>
                </ul>
              </li>
              <li>
                <h5>安装完成后注意事项</h5>
                <ul class="ul_i">
                  <li>在防火墙中打开安装时设置的端口</li>
                  <li>首次登录管理后台后请修改密码</li>
                  <li>如果使用的是IP证书,登录管理后台时,会有警告：<b><i>您的连接不是私密连接</i></b>(因为IP证书时自签的，不被证书机构认证)，请点击<b><i>高级</i></b>，然后点击<b><i>继续前往...(不安全)</i></b>即可</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h5>技术支持</h5>
            <ul class="ul_i">
              <li>
                用蝉鸣APP扫描以下二维码，跟客服人员联系。
                
                <div class="qrcode_box">
                  <div class="qrcode">
                    <div class="img">
                      <img src="../assets/supports/1.png" alt="">
                    </div>
                    <div class="name">
                      <div class="avatar">
                        <img src="../assets/supports/avatar.png" alt="" />
                      </div>
                      <div class="str">蝉鸣技术客服</div>
                    </div>
                  </div>
                </div>
              </li>
              <li>发送邮件到<a href="mailto:cicadasing@cicadasing.com">cicadasing@cicadasing.com</a></li>
            </ul>
          </li>
          <li>
            <h5>软件使用中的问题解答</h5>
            <ul class="ul_i qa_list">
              <li>
                <h5 class="q">Q1： 打开管理后台,输入用户名和密码登录时，若出现如下错误</h5>
                <div style="margin-bottom:10px;"><i>Error: Request failed with status code 404</i></div>
                <div class="a">A1:这是因为cicadasing程序没有完全启动,再等一会儿即可</div>
              </li>
            </ul>
          </li>
        </ul>
    </div>
  </div>
</template>
<style lang="scss">
#instructions{
  // min-height: 100vh;
  /* min-width: 100vw; */
  padding-top: 15px;
  background: #F6F6F6;
  .instructions_body{
    max-width:1000px;
    margin:15px auto;
    background: #fff;
    padding:15px 3%;
    // min-height: 100vh;
    h1{
      font-size:30px;
      // font-weight: bold;
    }
    .ul{
      padding:15px 18px;
      list-style: outside;
      li{
        padding-bottom:15px;
      }
      .ul_i{
        list-style: circle;
          padding-left:15px;
        li{
          padding-top:10px;
          padding-bottom: 0;
        }
        &.qa_list{
          .q{
            font-weight: normal;
            margin-bottom:10px;
          }
          .a{
            margin-bottom:10px;
          }
        }
          
      }
    }
  }
  .qrcode_box{
    margin-top:5px;
    overflow:hidden;
    padding: 15px;
    .qrcode{
      float:left;
      margin-right:5px;
      background: #FFFFFF;
      box-shadow: 0px 0px 14px 0px rgba(0, 53, 44, 0.25);
      border-radius: 2px;
      padding:5px;
      .img{
        img{
          width:180px;
        }
      }
      .name{
        display:flex;
        // justify-content: left;
        align-items: center;
        color:#333;
        .avatar{
          img{
            width:36px;
          }
        }
        .str{
          padding-left:5px;
          font-size:12px;
        }
      }
    }
  }
}
</style>

<script>
export default {
  title: "Dingo Group",	
  data() {
    return {
    };
  },
  methods: {
  },
  created(){
  }
};
</script>
